import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import OnTraccrCheckbox from '../../../common/inputs/OnTraccrCheckbox';

export default function HideIfEmptyInPDFCheckbox({
  isV3Form,
  configProps = {},
  setConfigProps,
}) {
  const { hideIfEmptyInPDF = false } = configProps;

  const onChange = useCallback((checked) => {
    setConfigProps({
      ...configProps,
      hideIfEmptyInPDF: checked,
    });
  }, [configProps, setConfigProps]);

  if (!isV3Form) return null;

  return (
    <OnTraccrCheckbox
      style={{ marginTop: 10 }}
      label="Hide in PDF if empty"
      value={hideIfEmptyInPDF}
      onChange={onChange}
      hoverNode={(
        <div style={{ width: 300 }}>
          <p>
            When enabled, this field and any PDF elements linked to this field
            are omitted from the PDF if the field has no entered data.
            Calculation fields with a result of zero are treated as empty.
          </p>
        </div>
      )}
    />
  );
}

HideIfEmptyInPDFCheckbox.propTypes = {
  isV3Form: PropTypes.bool,
  configProps: PropTypes.shape({}),
  setConfigProps: PropTypes.func.isRequired,
};

HideIfEmptyInPDFCheckbox.defaultProps = {
  isV3Form: false,
  configProps: {},
};
